import React, { useEffect, useState } from "react";
import Starbuck_card from "../assets/portfolio/Starbuck_card.jpg";
import GameLib from "../assets/portfolio/GameLib.jpg";
import Job from "../assets/portfolio/Job.jpg";
import MySkill from "../assets/portfolio/MySkill.jpg";
import Quran from "../assets/portfolio/Quran.jpg";
import Ecommerce from "../assets/portfolio/Ecommerce.jpg";
import AOS from 'aos';
import "aos/dist/aos.css";

const Portfolio = () => {
  const portfolio = [
    {
      id: 1,
      title: "Responsive Starbucks Details Card using HTML, CSS and JavaScript",
      src: Starbuck_card,
      demo: 'https://starbucks-promo-details.vercel.app/',
      code: 'https://github.com/alamnaga/Starbucks-Promo-Details/'
    },
    {
      id: 2,
      title: "E-commerce Platform with API Integration and Next.js Framework",
      src: Ecommerce,
      demo: 'https://next-ecommerce-alam.vercel.app/',
      code: 'https://gitlab.com/alamnaga/sanbercode-nextjs-batch-43/-/tree/main/sanber-next-commerce'
    },
    {
      id: 3,
      title: "Al-Quran with Next.js Framework: Enhancing Accessibility to the Holy Book",
      src: Quran,
      demo: 'https://alqurankita.vercel.app/',
      code: '#'
    },
    {
      id: 4,
      title: "MySkill Edutech - Responsive Landing Page using HTML & CSS only",
      src: MySkill,
      demo: 'https://myskill-responsive-landing-page.vercel.app/',
      code: 'https://github.com/alamnaga/E-Learning'
    },
    {
      id: 5,
      title: "Job Listings Website with ReactJS and API Integration for CRUD Operations",
      src: Job,
      demo: 'https://infoloker-alamnaga.netlify.app/',
      code: 'https://gitlab.com/alamnaga/sanbercode-reactjs-batch-42/-/tree/main/final-project'
    },
    {
      id: 6,
      title: "Game Library with ReactJS and API Integration for CRUD Operations",
      src: GameLib,
      demo: 'https://gamelibrary-reactjs.netlify.app/',
      code: 'https://gitlab.com/alamnaga/sanbercode-reactjs-batch-42/-/tree/main/quiz-3'
    },
  ];

  const [numToShow, setNumToShow] = useState(3);
  const handleClick = () => {
    setNumToShow(numToShow + 3);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-t from-white via-[#abd1c6] to-white w-full text-gray-700 md:h-auto lg:p-6"
    >
      <div className="max-w-screen-lg mb-9 mx-auto flex flex-col justify-center w-full h-auto" data-aos="fade-right" data-aos-delay="200" data-aos-once="true">
        <div className="pb-8 p-8 ">
          <p className="text-4xl font-logo inline border-gray-500">
            Portfolio📔
            <svg id="wave" style={{ transform: 'rotate(0deg)', transition: '0.3s', width: '13.125rem' }} viewBox="0 0 1440 100" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1={0} x2={0} y1={1} y2={0}><stop stopColor="rgba(0, 70, 67, 1)" offset="0%" /><stop stopColor="rgba(0, 30, 29, 1)" offset="100%" /></linearGradient></defs><path style={{ transform: 'translate(0, 0px)', opacity: 1 }} fill="url(#sw-gradient-0)" d="M0,40L120,33.3C240,27,480,13,720,16.7C960,20,1200,40,1440,53.3C1680,67,1920,73,2160,71.7C2400,70,2640,60,2880,46.7C3120,33,3360,17,3600,13.3C3840,10,4080,20,4320,30C4560,40,4800,50,5040,51.7C5280,53,5520,47,5760,36.7C6000,27,6240,13,6480,10C6720,7,6960,13,7200,26.7C7440,40,7680,60,7920,68.3C8160,77,8400,73,8640,66.7C8880,60,9120,50,9360,48.3C9600,47,9840,53,10080,48.3C10320,43,10560,27,10800,28.3C11040,30,11280,50,11520,58.3C11760,67,12000,63,12240,61.7C12480,60,12720,60,12960,53.3C13200,47,13440,33,13680,30C13920,27,14160,33,14400,35C14640,37,14880,33,15120,30C15360,27,15600,23,15840,25C16080,27,16320,33,16560,30C16800,27,17040,13,17160,6.7L17280,0L17280,100L17160,100C17040,100,16800,100,16560,100C16320,100,16080,100,15840,100C15600,100,15360,100,15120,100C14880,100,14640,100,14400,100C14160,100,13920,100,13680,100C13440,100,13200,100,12960,100C12720,100,12480,100,12240,100C12000,100,11760,100,11520,100C11280,100,11040,100,10800,100C10560,100,10320,100,10080,100C9840,100,9600,100,9360,100C9120,100,8880,100,8640,100C8400,100,8160,100,7920,100C7680,100,7440,100,7200,100C6960,100,6720,100,6480,100C6240,100,6000,100,5760,100C5520,100,5280,100,5040,100C4800,100,4560,100,4320,100C4080,100,3840,100,3600,100C3360,100,3120,100,2880,100C2640,100,2400,100,2160,100C1920,100,1680,100,1440,100C1200,100,960,100,720,100C480,100,240,100,120,100L0,100Z" /></svg>
          </p>
          <p className="pt-6 pb-2">Check out my portfolio right here! Take a closer look by clicking through to view demos and code snippets of my work, or browse my repositories on <a href="https://github.com/alamnaga" target="_blank" rel="noreferrer" className="underline hover:text-sky-600">Github</a>/<a href="https://gitlab.com/alamnaga" target="_blank" rel="noreferrer" className="underline hover:text-sky-600">Gitlab</a></p>
          <p className="text-xs text-[#0e8d88]">ℹ️ Info: Explore my Portfolio Design on my <a href="https://dribbble.com/alamnaga" target="_blank" rel="noreferrer" className="underline hover:text-sky-600">Dribbble</a></p>
        </div>

        <div className="grid sm:grid-cols-2 sm:mr-6 sm:ml-6 lg:p-6 md:grid-cols-3 md:mr-5 md:ml-5 gap-8 m-2 px-8 sm:px-0" >
        {portfolio.slice(0, numToShow).map(({ id, src, title, demo, code }) => (
          <div key={id} className="shadow-lg shadow-gray-900 rounded-lg bg-[#fffffe]" data-aos="flip-left" data-aos-delay="200" data-aos-once="true">
            <img
              src={src}
              alt=""
              className="rounded-t-md duration-200 hover:scale-105"
            />
            <div className="flex items-center justify-center">
              <p className="p-2 text-lg font-semibold text-[#001e1d]">{title}</p>
            </div>
            <div className="flex items-center justify-center rounded-b-md  text-[#001e1d] font-semibold">
              <button
                className="w-1/2 md:px-4 md:py-2 px-6 py-3 m-4 duration-200 text-[#001e1d] shadow-lg hover:scale-105 rounded-xl bg-gradient-to-tr from-[#fde680] to-[#ffb647]"
                onClick={() => window.open(demo, '_blank')}
              >
                Demo
              </button>

              <button
                className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-110 
                hover:underline hover:underline-offset-4 hover:decoration-4 hover:decoration-[#bd893c]"
                onClick={() => window.open(code, '_blank')}
              >
                Code
              </button>
            </div>
          </div>
        ))}
      </div>

      {numToShow < portfolio.length && (
        <div className="flex justify-center">
          <button
            className="px-8 py-3 mt-6 text-lg font-medium text-[#001e1d] bg-gradient-to-tr from-[#fde680] to-[#ffb647] rounded-full hover:scale-105 duration-200"
            onClick={handleClick}
          >
            Load More
          </button>
        </div>
      )}
      </div>
    </div>
  );
};

export default Portfolio;
